import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class OrderService extends BaseService {

    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.ORDERS(), data);
    }

    getByPos(id, data): Observable<any> {
        return this.getRequest(AppUrl.ORDERS_BY_POS(id), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.ORDERS_COUNT());
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.ORDERS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.ORDERS(id), data);
    }

    orderDeliveryStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.ORDER_DELIVERY_STATUS(id), data);
    }
}
